import type { PageHelp } from '../network-help.data';

export const L10N_tr_g4: Record<string, PageHelp> = {
  'trains-ticket': {
    title: 'Tren Bileti',
    tag: 'Düzenlenmiş e-bilet',
    tagline: 'Düzenlenmiş demiryolu e-bileti — rezervasyon referansı, vagon / koltuk, QR ve satışın kârı.',
    business: {
      lead: 'Bu, demiryolu satışının kanıtıdır — yolcunun binmek için okuttuğu rezervasyon referansı ve QR / barkod, ayrıca onaylanmış vagon ve koltuk. Ayrıca ticari döngüyü kapatarak acenteye rezervasyonda gerçekleşen marjı gösterir.',
      points: [
        { title: 'QR ile binin', desc: 'Yolcunun binmek için sunduğu şey referans ve barkoddur.' },
        { title: 'Vagon ve koltuk onaylı', desc: 'Tam vagon ve koltuk (ve yönü / durumu) biletin üzerindedir.' },
        { title: 'Kâr gerçekleşir', desc: 'Finansal özet bu satıştaki marjı açıkça gösterir.' },
      ],
    },
    software: {
      lead: 'Yolculuk, vagon / koltuk ve finansal bilgileri içeren bir bilet.',
      points: [
        { title: 'Başlık ve yolcu bandı', desc: 'Rezervasyon referansı, yolcu adı, bilet numarası, sınıf ve düzenlenme tarihi.' },
        { title: 'Yolculuk ve koltuk', desc: 'İşletmeci, sefer numarası, kalkış / varış istasyonları ve süre, ayrıca vagon / koltuk satırı ve barkod.' },
        { title: 'Finansallar ve işlemler', desc: 'Bir marj kenar çubuğu, ayrıca e-posta / kopyala / değiştir / iade kontrolleri.' },
      ],
    },
    related: ['trains-payment', 'bookings', 'booking-detail', 'refunds'],
  },

  'hotels-results': {
    title: 'Otel Sonuçları',
    tag: 'Otel araması',
    tagline: 'Konaklama için sıralanmış tesisler — siz karar vermeden önce satış modu ve iade politikası görünür.',
    business: {
      lead: 'Sonuçlar ekranı, arama için rezerve edilebilir her tesisi gösterir; kendi sözleşmeli envanterini bağlı tedarikle harmanlar. Ticari açıdan önemli rozetler — Anında (Instant) vs Talep Üzerine (On-Request), iade edilebilir vs edilemez — kartın üzerindedir; böylece acente, rezervasyonun nasıl onaylanacağını ve paranın ne zaman hareket edeceğini bilerek seçer.',
      points: [
        { title: 'Kendi + bağlı tedarik birleştirildi', desc: 'Platformun Otel Tesisi modülünden ve harici tedarikçilerden gelen odalar tek bir listede sıralanır.' },
        { title: 'Satış modu görünür', desc: 'Anında (Instant) tıklamada onaylanır; Talep Üzerine (On-Request) bir tedarikçi kabul edene kadar rezervasyonu tutar — rozet, acenteye hangisini aldığını söyler.' },
        { title: 'İade politikası önden', desc: 'Ücretsiz iptal vs iade edilemez hem bir filtre hem de bir etikettir; böylece acente doğru politikayı sunar.' },
      ],
    },
    software: {
      lead: 'Bir ücret şeridi ve oda seçim çekmecesi içeren filtrelenebilir bir tesis listesi.',
      points: [
        { title: 'Tesisleri filtreleyin', desc: 'Kenar çubuğu; sıralama, yıldız derecesi, fiyat aralığı, iade politikası, bölge ve tedarikçiye göre daraltır, ayrıca ad / bölge / zincir üzerinde serbest metin.' },
        { title: 'Ücret şeridini tarayın', desc: 'Giriş tarihi çevresinde 7 günlük gecelik fiyat takvimi; yeniden aramak için bir tarihe tıklayın.' },
        { title: 'Rezerve etmek için oda seçin', desc: 'Kartlar en iyi gecelik oranı liste fiyatına karşı, değerlendirme puanını ve iade etiketini gösterir; “Oda seç” rezervasyon çekmecesini açar.' },
      ],
    },
    flow: {
      lead: 'Sonuçlar sayfasından rezervasyon, voucher üzerinde sonlanan bir çekmecede (ayrı sayfalarda değil) tamamlanır.',
      steps: [
        { title: 'Oda ve tarife seçin', desc: 'Bir oda tipi ve tarife planı seçin; toplam tüm geceleri artı vergileri kapsar, iade politikası gösterilir.' },
        { title: 'Misafir bilgileri', desc: 'Oda başına misafir başına bir form (unvan, ad, doğum tarihi, uyruk, pasaport); kaydedilmiş bir müşteri CRM’den ön doldurur. Baş misafir rezervasyon irtibatını taşır.' },
        { title: 'Ödeme (+ ek hizmetler)', desc: 'Ödeme yöntemini seçin; kendi envanterinizde isteğe bağlı ek hizmetler (otopark, spa…) burada eklenebilir.' },
        { title: 'İnceleyin ve onaylayın', desc: 'Odaların, misafirlerin ve toplamın son özeti; onaylamak siparişi oluşturur ve vvoucher’ı düzenler.' },
      ],
    },
    related: ['hotels-search', 'hotels-ticket', 'supply-properties', 'markup'],
  },

  'hotels-ticket': {
    title: 'Otel Vaucheri',
    tag: 'Düzenlenmiş voucher',
    tagline: 'Onaylanmış otel vaucheri — tesis, konaklama tarihleri, misafir listesi ve ücretler.',
    business: {
      lead: 'Vaucher, misafirin onaylanmış bir konaklamaya dair kanıtı ve otelin girişte kabul ettiği belgedir. Tesisi, tarife planını ve pansiyonu, giriş / çıkış tarihlerini ve her misafirin belgesini, acentenin e-postayla gönderebileceği veya yazdırabileceği tek bir kayıtta birleştirir.',
      points: [
        { title: 'Giriş için kanıt', desc: 'Referans artı oda başına misafir listesi (belgelerle birlikte) otelin varışta doğruladığı şeydir.' },
        { title: 'Kayıtta pansiyon ve iade', desc: 'Tarife planının pansiyonu ve iptal politikası, bir sözleşmenin içine gömülü değil, vaucher üzerinde belirtilir.' },
        { title: 'Buradan servis', desc: 'Güzergâhı e-postayla gönderin, referansı kopyalayın veya rezervasyonu değiştirin / iptal edin.' },
      ],
    },
    software: {
      lead: 'Tesis, bir konaklama şeridi, oda başına misafir listesi ve ücretleri içeren bir vaucher.',
      points: [
        { title: 'Başlık ve tesis', desc: 'Bir “vaucher düzenlendi” rozeti ve referans, Onaylandı / pansiyon / iade etiketleriyle tesis ve e-posta / yazdır / indir.' },
        { title: 'Konaklama şeridi', desc: 'Giriş tarihi (15:00’ten itibaren), gece sayısı ve çıkış (12:00’ye kadar).' },
        { title: 'Misafirler ve ücretler', desc: 'Belgelerle birlikte oda başına misafir listesi, ayrıca bir ücret kenar çubuğu (oda taban, vergiler, toplam).' },
      ],
    },
    related: ['hotels-results', 'bookings', 'booking-detail'],
  },

  'tours-new': {
    title: 'Tur Paketi Oluşturucu',
    tag: 'Paket oluşturma',
    tagline: 'Çok hizmetli bir paket oluşturun — güzergâh, uçuşlar, oteller, dahiliyetler ve doluluk başına fiyatlandırma — ardından satmak için yayınlayın.',
    business: {
      lead: 'Bu, Turların tedarik tarafıdır: bir işletmecinin, acentelerin daha sonra sattığı ürünü oluşturduğu yerdir. Bir paket; uçuşları, otelleri, transferleri ve etkinlikleri kendi güzergâhı, kalkış aralığı ve paket fiyatı olan tek bir SKU’da toplar — böylece bir manşet fiyatı üzerinden pazarlanabilir ve marjı satır satır savunulmak yerine tek bir birim olarak yönetilebilir.',
      points: [
        { title: 'Tek SKU, birçok bileşen', desc: 'Uçuşlar ve bir otel her zaman dahildir; vize, transferler ve sigorta isteğe bağlı geçişlerdir — hepsi tek bir kayıt olarak satılır.' },
        { title: 'Doluluk başına fiyatlandırılır', desc: 'Her otel sepeti doluluk rollerine göre fiyatlandırılır (Yetişkin, Yetişkin-tek, Çocuk-yataklı, Çocuk-yataksız, Bebek); böylece bir aile veya yalnız seyahat eden her biri doğru fiyatı alır.' },
        { title: 'Yayın durumu satışı kontrol eder', desc: 'Bir paket Pasif → Önizleme → Aktif olarak ilerler; yalnızca Aktif kalkışlar (geçmiş olmayanlar) Turlar sayfasından rezerve edilebilir.' },
      ],
    },
    software: {
      lead: 'Temellerden yayınlamaya bir adımlı sihirbaz; ilerlemeden önce her adım doğrulanır.',
      points: [
        { title: 'Temeller, güzergâh, bileşenler', desc: 'Ad, şehirler, tarihler, kategori ve rozetler; günlük konaklama şehriyle gün gün bir plan; ve kataloğdan veya serbest metinden bir dahil / hariç listesi.' },
        { title: 'Uçuşlar ve otel sepetleri', desc: 'Bir uçuş ekleyin (tur modunda ara-ve-rezerve et veya manuel) ve çok şehirli otel sepetleri oluşturun (şehir + otel + oda).' },
        { title: 'Fiyatlandırma ve yayınlama', desc: 'Sepet başına × doluluk başına bir fiyat matrisi, ardından dağıtım bayraklarıyla yayınlama (öne çıkan, haftalık posta, pazar kısıtlaması, B2C white-label).' },
      ],
    },
    related: ['tours', 'flights-search', 'hotels-search', 'supply-properties'],
  },

  visa: {
    title: 'Vize',
    tag: 'Vize hizmetleri',
    tagline: 'Katalog, uygunluk ve gişe arkasında memur çalışma alanı ile rezerve edilebilir vize başvuruları.',
    business: {
      lead: 'Vize, giriş izni işlemlerini rezerve edilebilir bir hizmete dönüştürür. Acente vizeyi, bir uçuşu veya oteli sattığı gibi satar — fiyatı, teslim süresi ve tanımlı bir teslimatı olan bir ürün olarak — perde arkasında belgeleri toplayan, konsolosluğa sunan ve kararı geri getiren bir arka ofis memur akışıyla.',
      points: [
        { title: 'Vize bir üründür', desc: 'Her varış × vize türünün fiyatlandırma, teslim süresi ve belge gereksinimleri olan bir katalog girişi vardır; acentenin kâr marjı bunun üzerine katmanlanır.' },
        { title: 'Uygunluk satışı geçitler', desc: 'Bir yolcunun uyruğu, ziyaret amacı ve geçerlilik aralığı, hangi katalog girişlerinin gerçekten satılabilir olduğunu belirler — arama yalnızca geçerli kombinasyonları sunar.' },
        { title: 'Para tahsil edilir, hizmet teslim edilir', desc: 'Ödeme rezervasyonda alınır; memur çalışma alanı ilerlemeyi belgeler-alındı’dan karar-döndü’ye kadar izler.' },
      ],
    },
    software: {
      lead: 'Bir vize kataloğu araması, ayrıca teslimat tarafı için bir arka ofis memur çalışma alanı.',
      points: [
        { title: 'Kataloğu arayın', desc: 'Varış, vize türü ve yolcu uyruğu sonuçları yönlendirir; yalnızca satılabilir kombinasyonlar görünür.' },
        { title: 'Vizeyi rezerve edin', desc: 'Bir giriş seçmek yolcu / belge-yükleme formunu ve ödemeyi açar; sonuç bir vize rezervasyonudur.' },
        { title: 'Teslimata kadar izleyin', desc: 'Memur çalışma alanı her açık vakayı, aşamasını, belgelerini ve konsolosluk tarafı durumunu gösterir — acente bunu müşteriyi güncellemek için kullanır.' },
      ],
    },
    flow: {
      lead: 'Bir vize rezervasyonu iki yarımdır — müşteriye dönük satış, ardından karara kadar arka ofis teslimatı.',
      steps: [
        { title: 'Kataloğu filtreleyin', desc: 'Varış ülkesi, vize türü (turist / iş / transit / öğrenci) ve yolcu uyruğu uygunluğu yönlendirir; uygun olmayan kombinasyonlar gizlenir.' },
        { title: 'Girişi okuyun', desc: 'Her katalog girişi ücreti, teslim süresini, belge gereksinimlerini ve konsolosluğun karar kanalını gösterir.' },
        { title: 'Yolcuyu kaydedin', desc: 'Yolcu bilgileri (pasaport, seyahat tarihleri, amaç, destekleyici ayrıntılar) vaka dosyasını yönlendirir.' },
        { title: 'Belgeleri yükleyin', desc: 'Pasaport taraması, fotoğraf, davetiye, mali kanıt — gerekli set her katalog girişine göre değişir.' },
        { title: 'Ödeyin ve vakayı açın', desc: 'Ödeme rezervasyonda tahsil edilir. Vaka, memur çalışma alanında "belgeler alındı" aşamasında açılır.' },
        { title: 'Memur teslimatı', desc: 'Memur belgeleri inceler, konsolosluğa sunar, durumu izler, kararı alır ve vakayı bir vize belgesi veya bir ret ile kapatır.' },
        { title: 'Müşteriye teslim edin', desc: 'Vize belgesi (veya ret açıklaması) rezervasyona eklenir ve acentenin paylaşması için erişilebilir kılınır.' },
      ],
    },
    modes: {
      lead: 'Vize girişleri vize türüne göre kataloglanır; akış türe göre uyarlanır.',
      modes: [
        { name: 'Turist', when: 'tatil seyahati', desc: 'Standart ziyaretçi vizesi. Çoğu varışta daha düşük ücret, daha hızlı teslim süresi. Belge seti genellikle pasaport + fotoğraf + güzergâhtır.' },
        { name: 'İş', when: 'iş / konferans ziyaretleri', desc: 'Ev sahibi kuruluştan bir davet mektubu gerektirir. Daha yüksek ücret, benzer teslim süresi, bazen konsoloslukta yüz yüze bir randevu.' },
        { name: 'Transit', when: 'varışta aktarma', desc: 'En kısa geçerlilik, en ucuz ücret. Yalnızca transit aralığı için geçerli. Her varış bir tane sunmaz; arama bunları buna göre filtreler.' },
        { name: 'Öğrenci', when: 'yerel bir kuruma resmi kabul', desc: 'Kabul kanıtı ve genellikle bir mali teminat gerektirir. En uzun teslim süresi; en yüksek ücret. Memur çalışma alanı uzatılmış belge döngüsünü izler.' },
      ],
    },
    examples: [
      {
        title: 'Türkiye turist vizesi · 1 yolcu · 21 günlük teslim süresi',
        rows: [
          { label: 'Konsolosluk ücreti', value: '4,500,000' },
          { label: 'Hizmet ücreti (acente işlemi)', value: '1,500,000' },
          { label: 'Perakende MARKUP · brütün +%10’u', value: '+600,000', accent: 'success' },
          { label: 'Yolcu toplamı', value: '6,600,000', strong: true },
        ],
        note: 'Konsolosluk ücreti aktarımlıdır; acente konsolosluk maliyeti üzerinden değil, hizmet ücreti ve perakende kâr marjı üzerinden kâr eder.',
      },
    ],
    related: ['flights-search', 'reference-data', 'markup'],
  },

  cip: {
    title: 'CIP',
    tag: 'Havalimanı konsiyerj',
    tagline: 'Bir seyahatin yanında satılan karşılama-ve-yardım ve VIP havalimanı konsiyerj hizmetleri.',
    business: {
      lead: 'CIP (Commercially Important Person) havalimanı konsiyerjidir — varış, transit veya kalkışta bir müşteriyi bir havalimanı görevlisiyle eşleştiren bir karşılama-ve-yardım hizmeti. Ticari açıdan, acentenin uygun herhangi bir seyahate ekleyebileceği küçük, yüksek marjlı bir ek hizmettir ve çoğunlukla doğrudan yolculara değil bayii acentelerine satılır.',
      points: [
        { title: 'Yardımcı gelir', desc: 'Bir konsiyerj rezervasyonunun teslimi ucuz, marjı yüksektir ve temel uçuş/otel satışıyla rekabet etmez — saf ek gelir.' },
        { title: 'Yalnızca bayii', desc: 'CIP kataloğu acentelere sunulur (müşterilere değil) — bu, bayiinin kendi son müşterisine yeniden fiyatlandırdığı bir toptan üründür.' },
        { title: 'cip-service’e ait', desc: 'CIP katalog verileri content-service’e değil, özel cip-service’e aittir; böylece fiyatlandırma ve müsaitlik, referans verilerinin geri kalanından bağımsız olarak yönetilir.' },
      ],
    },
    software: {
      lead: 'cip-service tarafından desteklenen özel bir konsiyerj kataloğu arama ve rezervasyon ekranı.',
      points: [
        { title: 'Kataloğu arayın', desc: 'Havalimanı, hizmet türü (varış / kalkış / transit) ve yolcu sayısı sonuçları yönlendirir.' },
        { title: 'Hizmeti rezerve edin', desc: 'Bir hizmet seçmek yolcu formunu ve ödeme akışını açar; sonuç, Tüm Rezervasyonlar’da diğer her ürünün yanında görünen bir CIP rezervasyonudur.' },
        { title: 'Uçtan uca fiyatlandırılır', desc: 'Para rezervasyonda tahsil edilir; muhasebe yığınına defter mutabakatı Faz-3 yol haritasındadır.' },
      ],
    },
    flow: {
      lead: 'Bir CIP rezervasyonu kısadır — yolcu bir havalimanı, bir an (varış / kalkış / transit) ve bir hizmet seviyesi seçer.',
      steps: [
        { title: 'Havalimanını seçin', desc: 'Havalimanı kodu hangi görevli ağının mevcut olduğunu belirler; her havalimanının kapsamı yoktur.' },
        { title: 'Anı seçin', desc: 'Varış, kalkış veya transit — görevli her biri için terminalin içinde farklı noktalarda başlar ve biter.' },
        { title: 'Hizmet seviyesini seçin', desc: 'Karşılama-ve-yardım, VIP veya tam lounge erişimi — her kademe daha fazla ayrıcalık paketler (hızlı geçiş, buggy, lounge süresi).' },
        { title: 'Uçuş bilgilerini ayarlayın', desc: 'Görevlinin doğru yolcuyla buluşabilmesi için uçuş numarası ve tarihi.' },
        { title: 'Yolcuları kaydedin + ödeyin', desc: 'Yolcu adları + ödeme; görevli görevi alır ve müşteri buluşma noktasıyla birlikte bir onay alır.' },
      ],
    },
    modes: {
      lead: 'CIP bir seyahatte üç andan birinde ve birkaç hizmet seviyesinden birinde satın alınır — katalog bunların bir matrisidir.',
      modes: [
        { name: 'Arrival', when: 'gelen uçuş', desc: 'Görevli yolcuyu kapıda / körükte karşılar, göç ve bagajı halleder, kara tarafına eşlik eder. VIP’ler ve ilk kez gelen ziyaretçiler arasında popüler.' },
        { name: 'Departure', when: 'giden uçuş', desc: 'Görevli yolcuyu kara tarafında karşılar, check-in ve güvenliği halleder, kapıya veya lounge’a eşlik eder.' },
        { name: 'Transit', when: 'aktarmalı uçuş', desc: 'Görevli uçuşlar arasında buluşur, terminaller ve kapılar arası transferi halleder. Özellikle kısa aktarmalarda değerli.' },
        { name: 'Meet & Assist', when: 'temel kademe', desc: 'Bir görevli ve fiziksel yardım — temel hizmet.' },
        { name: 'VIP', when: 'premium kademe', desc: 'Göç ve güvenlikten hızlı geçiş, terminal içinde buggy taşıma, bazen lounge erişimi ekler.' },
      ],
    },
    examples: [
      {
        title: 'DXB varış · VIP · 2 yolcu',
        rows: [
          { label: 'Taban görevli ücreti (yolcu başına) × 2', value: '2,800,000' },
          { label: 'Wholesale MARKUP · +%8 (görevli acentesi)', value: '+224,000', accent: 'info' },
          { label: 'Perakende MARKUP · brütün +%15’i', value: '+453,600', accent: 'success' },
          { label: 'Yolcu toplamı', value: '3,477,600', strong: true },
        ],
        note: 'CIP yüksek marjlı bir ek hizmettir — burada %20–30 karma kâr marjı normaldir, uçuşlardaki %5–10’a karşı.',
      },
    ],
    related: ['flights-search', 'reference-data', 'markup'],
  },

  ground: {
    title: 'Kara Taşımacılığı',
    tag: 'Kara hizmetleri',
    tagline: 'Noktadan noktaya transferler, şoförlü hizmetler ve kısa mesafeli karayolu taşımacılığı.',
    business: {
      lead: 'Kara Taşımacılığı, bir seyahatin karayolu ayağını satar — havalimanı transferleri, şoförlü karşılamalar, günlük kiralık araçlar — rezerve edilebilir bir ürün olarak. Uçuş veya otel satışının "A’dan B’ye karadan git" tamamlayıcısıdır ve acentenin bir müşterinin tüm seyahatini tek bir sepette kapatmasına olanak tanır.',
      points: [
        { title: 'Seyahati kapatır', desc: 'Acenteyle zaten bir uçuş ve bir otel rezerve etmiş bir müşterinin bariz bir sonraki sorusu vardır — birinden diğerine nasıl giderim. Kara buna kendi bünyesinde yanıt verir.' },
        { title: 'Bir uçuşa eklenir', desc: 'Havalimanı transferleri genellikle uçuş seçildikten sonra satın alınır; karşılama zamanı uçuşun varışından devralınabilir, bu da işletmeci çabasını azaltır.' },
        { title: 'Katmanlı fiyatlandırma geçerlidir', desc: 'Bir uçuşu fiyatlandıran aynı Wholesale / Distribution / Retail motoru bir kara hizmetini de fiyatlandırır — partner kapsamlı bir kural burada da çalışır.' },
      ],
    },
    software: {
      lead: 'Araç sınıfı seçenekleri ve bir rezervasyon akışı ile bir alış / bırakış araması.',
      points: [
        { title: 'Ayağı oluşturun', desc: 'Alış konumu, bırakış konumu, tarih ve yolcu sayısı aramayı yönlendirir; araç sınıfı (sedan / SUV / minibüs) seçimi daraltır.' },
        { title: 'Araç satırını okuyun', desc: 'Her sonuç işletmeciyi, araç sınıfını, fiyatı ve tahmini süreyi gösterir.' },
        { title: 'Rezervasyona ilerleyin', desc: 'Seçilen bir araç yolcu / alış-bilgileri formunu ve ödemeyi açar; kayıt Tüm Rezervasyonlar’a katılır.' },
      ],
    },
    flow: {
      lead: 'Bir kara rezervasyonu kısadır ve genellikle mevcut bir uçuşa eklenir — alış konumu, bırakış, zamanlama, araç sınıfı.',
      steps: [
        { title: 'Alış + bırakış seçin', desc: 'Şehirden şehre, havalimanından otele veya noktadan noktaya. Havalimanı alışı, aynı PNR’deki eşleşen bir uçuştan ön doldurulur.' },
        { title: 'Tarih + saat seçin', desc: 'Alış zaman damgası — havalimanı transferleri için uçuşun varışından devralınabilir (standart bir tampon için ayarlanmış).' },
        { title: 'Araç sınıfı seçin', desc: 'Yalnız / çift için sedan, aile için SUV, grup için minibüs. Araç sınıfı kapasiteyi, bagajı ve fiyatı yönlendirir.' },
        { title: 'Yolcuları kaydedin + ödeyin', desc: 'Baş yolcu adı ve telefonu + ödeme; sürücü görevlendirilir ve yolcu alış bilgilerini alır.' },
      ],
    },
    modes: {
      lead: 'Kara hizmetleri seyahat şekline göre — tek seferlik bir transfer veya süregelen bir kiralama — ve araç sınıfına göre ayrılır.',
      modes: [
        { name: 'Havalimanı transferi', when: 'gelen / giden uçuş', desc: 'Havalimanından otele (veya tersi) tek seferlik alış. En ucuz ve en yaygın. Alış zamanlaması uçuş varışından devralınır.' },
        { name: 'Noktadan noktaya', when: 'şehir → şehir veya şehirlerarası sıçrama', desc: 'Şehir veya bölgede başka bir yere tek bırakış. Fiyat mesafeyle ölçeklenir.' },
        { name: 'Şoförlü / saatlik', when: 'iş toplantıları / VIP gün', desc: 'Rezerve edilmiş bir saat bloğu için sürücü + araç. Yolcu günün rotasını belirler.' },
        { name: 'Günlük kiralama', when: 'tam gün gezi', desc: 'Tam gün araç + sürücü, genellikle maksimum kilometre payı ile. Saatlik bir bloktan daha yüksek fiyat.' },
      ],
    },
    examples: [
      {
        title: 'DXB havalimanı → otel · SUV · 2 yolcu + bagaj',
        rows: [
          { label: 'Taban transfer ücreti', value: '600,000' },
          { label: 'Wholesale MARKUP · +%5 (işletmeci marjı)', value: '+30,000', accent: 'info' },
          { label: 'Perakende MARKUP · brütün +%10’u', value: '+63,000', accent: 'success' },
          { label: 'Yolcu toplamı', value: '693,000', strong: true },
        ],
        note: 'Mevcut bir uçuş PNR’sine eklenen bir kara hizmeti rezervasyon kaydını paylaşır — tek ödeme, tek vaucher, tek iade akışı.',
      },
    ],
    related: ['flights-search', 'buses-search', 'markup'],
  },

  sim: {
    title: 'SIM Kartlar',
    tag: 'Seyahat bağlantısı',
    tagline: 'Herhangi bir yurt dışı seyahatine ücretli bir ek olarak satılan yalnızca veri seyahat SIM’leri / eSIM’leri.',
    business: {
      lead: 'SIM Kartlar, seyahatin kendisiyle birlikte varış için bir veri planı satar. Müşteri dolaşım ücretlerinden kaçınır, acente küçük bir marj kazanır ve teslimat (fiziksel SIM gönderilir veya eSIM QR teslim edilir) mal maliyetini düşük tutacak kadar incedir.',
      points: [
        { title: 'Saf bir ek hizmet', desc: 'Birim başına marj küçüktür ancak ekleme maliyeti ihmal edilebilir; her yurt dışı tatil seyahatinde artımlı gelirdir.' },
        { title: 'Fiziksel + eSIM', desc: 'Fiziksel SIM’ler bir teslimat adresi ve teslim süresi gerektirir; eSIM’ler rezervasyonda hemen bir QR kodu olarak teslim edilir, bu da akışı değiştirir.' },
        { title: 'Varış kapsamlı', desc: 'Her plan bir ülke veya bölgeye ve bir veri hakkı / geçerlilik aralığına bağlıdır — katalog bu kombinasyonların bir matrisidir.' },
      ],
    },
    software: {
      lead: 'SIM kataloğu tarafından desteklenen bir varış + plan araması.',
      points: [
        { title: 'Kataloğu arayın', desc: 'Varış ülkesi ve geçerlilik aralığı sonuçları yönlendirir; veri hakkı daha da daraltır.' },
        { title: 'Plan satırını okuyun', desc: 'Her satır işletmeciyi, veri hakkını, geçerliliği ve fiyatı gösterir; SIM türü (fiziksel vs eSIM) teslimatı etkiler.' },
        { title: 'Planı rezerve edin', desc: 'Bir plan seçmek yolcu / teslimat-bilgileri formunu ve ödemeyi açar; eSIM kayıtları anında teslim edilir, fiziksel SIM’ler bir teslimat planlar.' },
      ],
    },
    flow: {
      lead: 'Bir SIM rezervasyonu en kısa envanter akışlarından biridir — varış, hak, SIM türü, teslim.',
      steps: [
        { title: 'Varışı seçin', desc: 'Ülke veya bölge — katalog işletmeciye göre değil, kapsam alanına göre dizinlenir.' },
        { title: 'Geçerlilik aralığını seçin', desc: 'Seyahat uzunluğu hangi planların uygulanacağını yönlendirir — 7 günlük bir plan 21 günlük bir seyahate uymaz.' },
        { title: 'Hakkı seçin', desc: 'Veri bütçesi (sınırsız / 10GB / 20GB) daha da daraltır; sınırsız planlar genellikle adil kullanım sınırından sonra hızı düşürür.' },
        { title: 'SIM türü seçin', desc: 'Fiziksel SIM (teslimat adresi + teslim süresi gerektirir) veya eSIM (rezervasyonda teslim edilen QR). Yolcunun telefon uyumluluğu seçimi belirler.' },
        { title: 'Kaydedin + ödeyin', desc: 'Yolcu + teslimat adresi (yalnızca fiziksel) + ödeme. eSIM QR onayda hemen görünür; fiziksel SIM sevkiyatı planlanır.' },
      ],
    },
    modes: {
      lead: 'İki boyut önemlidir — fiziksel vs eSIM teslimatı ve coğrafi kapsam.',
      modes: [
        { name: 'Fiziksel SIM', when: 'yolcunun telefonu eSIM desteklemiyor', desc: 'Yolcunun adresine gönderilen (veya bir partner masasından alınan) bir nano / mikro SIM. Çoğu rotada 3–5 gün teslim süresi gerektirir, bu yüzden erken rezerve edin.' },
        { name: 'eSIM', when: 'yolcunun telefonu eSIM destekliyor (çoğu modern akıllı telefon)', desc: 'Rezervasyonda teslim edilen QR kodu — sevkiyat yok, teslim süresi yok. Yolcu varışta okutur ve profil etkinleşir. Acenteye sıfır mal maliyeti.' },
        { name: 'Ülkeye özel', when: 'tek varışlı seyahat', desc: 'Plan bir ülkede geçerlidir. GB başına en ucuz oran.' },
        { name: 'Bölgesel', when: 'çok ülkeli seyahat (ör. Avrupa sıçraması)', desc: 'Plan tanımlı bir bölgede geçerlidir (AB geneli, Asya-Pasifik, Körfez). GB başına daha yüksek oran ama her sınırda SIM değiştirmeye gerek yok.' },
        { name: 'Küresel', when: 'çok bölgeli uzun seyahat', desc: 'Plan geniş bir ülke listesinde geçerlidir — 100+ ülke. GB başına en yüksek oran; dünya turu veya iş seyahati yapanlara uygun.' },
      ],
    },
    examples: [
      {
        title: 'Türkiye · 10 gün 10GB · eSIM · 1 yolcu',
        rows: [
          { label: 'Tedarikçi plan maliyeti', value: '600,000' },
          { label: 'Perakende MARKUP · +%30 (yüksek marjlı ek hizmet)', value: '+180,000', accent: 'success' },
          { label: 'Yolcu toplamı', value: '780,000', strong: true },
        ],
        note: 'eSIM’in sıfır teslimat maliyeti vardır — QR tedarikçi tarafından üretilir ve onayda teslim edilir, böylece tüm kâr marjı marja düşer.',
      },
      {
        title: 'Aynı seyahat · fiziksel SIM',
        rows: [
          { label: 'Tedarikçi plan maliyeti', value: '600,000' },
          { label: 'Kargo', value: '100,000' },
          { label: 'Perakende MARKUP · brütün +%25’i', value: '+175,000', accent: 'success' },
          { label: 'Yolcu toplamı', value: '875,000', strong: true },
        ],
        note: 'Fiziksel SIM’ler kargo maliyeti ve kargo teslim süresi ekler — müşterinin telefonu desteklediğinde eSIM sürümü genellikle daha iyi bir satıştır.',
      },
    ],
    related: ['visa', 'insurance', 'flights-search'],
  },

  insurance: {
    title: 'Seyahat Sigortası',
    tag: 'Seyahat koruması',
    tagline: 'Bir seyahate ek olarak satılan rezerve edilebilir seyahat sigortası poliçeleri.',
    business: {
      lead: 'Seyahat Sigortası, müşteriyi seyahat aksaklıklarına (gecikmeler, iptaller, tıbbi, bagaj) karşı korur ve acenteye bir yardımcı gelir kalemi sağlar. Bazı varışlar geçerli kapsamı bir vize koşulu olarak gerektirir, bu yüzden saf isteğe bağlı yerine bir uyum ürünü de olabilir.',
      points: [
        { title: 'İsteğe bağlı ve zorunlu ikisi de var', desc: 'Bazı vizeler için hak kazanmak amacıyla kapsam gereklidir; saf tatil seyahatleri için ise acentenin kapanışta üst-sattığı bir isteğe bağlıdır.' },
        { title: 'Kademeli planlar', desc: 'Bir plan kapsam limitleri ve süresiyle tanımlanır — müşteri risk toleransına ve bütçesine uyan bir kademe seçer.' },
        { title: 'Harici olarak sigortalanır', desc: 'Platform poliçeyi sigortalamaz — bir üçüncü taraf ürünü satar ve ortaya çıkan poliçe kaydını müşterinin seyahatine rezerve eder.' },
      ],
    },
    software: {
      lead: 'Bağlı sigorta kataloğu üzerinde bir yolcu + varış araması.',
      points: [
        { title: 'Kapsamı oluşturun', desc: 'Varış, seyahat tarihleri ve yolcu yaşları sonuçları yönlendirir; kapsam kademesi planı daraltır.' },
        { title: 'Plan satırını okuyun', desc: 'Her sonuç sigortacıyı, kapsam limitlerini ve fiyatı gösterir; poliçe belgeleri seçimde açılır.' },
        { title: 'Poliçeyi rezerve edin', desc: 'Bir plan seçmek yolcu formunu ve ödemeyi açar; poliçe kaydı ve belgeleri müşterinin seyahatine eklenir.' },
      ],
    },
    flow: {
      lead: 'Bir poliçe rezervasyonu kısadır — varış, seyahat tarihleri, yolcu yaşları, kademe, ödeme.',
      steps: [
        { title: 'Seyahat şeklini seçin', desc: 'Varış ülkesi / bölgesi, seyahat tarihleri ve her yolcunun yaşı (oran yaş bandıyla ölçeklenir).' },
        { title: 'Bir kapsam kademesi seçin', desc: 'Temel yalnızca temel şeyleri kapsar; Standart bagaj / gecikme ekler; Premium tam tıbbi + seyahat iptalini ekler. Seyahatin risk altındaki değerine uyacak şekilde seçin.' },
        { title: 'Planı okuyun', desc: 'Her plan satır başına kapsam limitlerini (tıbbi, iptal, bagaj) ve istisnaları listeler. Poliçe belgeleri aynı ekranda açılır.' },
        { title: 'Yolcuları kaydedin + ödeyin', desc: 'Yolcu adları, doğum tarihleri ve pasaport numaraları + ödeme; poliçe rezervasyonda düzenlenir.' },
        { title: 'Poliçe belgelerini alın', desc: 'Poliçe PDF’i + sertifikası rezervasyona eklenir. Bazı varışlar konsolosluk başvurusunda sertifikayı gerektirir.' },
      ],
    },
    modes: {
      lead: 'Sigorta iki eksene göre fiyatlandırılır — kapsam kademesi (neyin kapsandığı) ve seyahat şekli (tek seyahat vs yıllık).',
      modes: [
        { name: 'Temel kademe', when: 'yurt içi / kısa tatil seyahatleri', desc: 'Tıbbi acil durum + geri gönderme. Bagaj ve iptal dahil değil. En ucuz prim.' },
        { name: 'Standart kademe', when: 'çoğu tatil seyahati', desc: 'Bagaj kaybı, seyahat gecikmesi ve sınırlı iptal ekler. En çok satılan kademe.' },
        { name: 'Premium kademe', when: 'pahalı seyahatler veya yaşlı yolcular', desc: 'Tam tıbbi (daha yüksek limitler), herhangi bir nedenle tam iptal, macera etkinlikleri ekler. En yüksek prim.' },
        { name: 'Tek seyahat', when: 'önümüzdeki haftalarda bir seyahat', desc: 'Belirli bir tarih aralığını kapsar (seyahatin başlangıcı → sonu). Ara sıra seyahat edenler için en ucuzu.' },
        { name: 'Yıllık çok seyahatli', when: 'sık iş veya tatil seyahati', desc: 'Seyahat başına bir uzunluk sınırına kadar (genellikle 30–60 gün) bir yıl içindeki her seyahati kapsar. Yılda 3+ seyahatte her seferinde tek seyahat almaktan daha ucuz.' },
      ],
    },
    examples: [
      {
        title: 'Türkiye · 10 günlük seyahat · Standart kademe · 2 yetişkin + 1 çocuk',
        rows: [
          { label: 'Taban prim (yetişkin) × 2', value: '1,400,000' },
          { label: 'Taban prim (çocuk)', value: '400,000' },
          { label: 'Ara toplam', value: '1,800,000' },
          { label: 'Perakende MARKUP · +%20 komisyon', value: '+360,000', accent: 'success' },
          { label: 'Yolcu toplamı', value: '2,160,000', strong: true },
        ],
        note: 'Sigorta komisyonları genellikle primin %15–25’idir — rezervasyon başına sağlam bir yardımcı marj ve tek bir poliçe seyahatteki herkesi kapsar.',
      },
    ],
    related: ['visa', 'sim', 'flights-search'],
  },

  bookings: {
    title: 'Tüm Rezervasyonlar',
    tag: 'Sipariş defteri',
    tagline: 'Acentenin yaptığı her sipariş, her ürün genelinde, tek bir listede.',
    business: {
      lead: 'Tüm Rezervasyonlar, satılan her şeyin operasyonel kaydıdır — uçuşlar, oteller, turlar, taşımacılık, vizeler, CIP — birleşik siparişler olarak. Personelin bir müşterinin rezervasyonunu servis etmek için bulduğu yerdir: yeniden düzenleme, ekstra ekleme, iptal, iade veya sadece nerede durduğunu kontrol etme.',
      points: [
        { title: 'Tek sipariş, birçok ürün', desc: 'Tek bir sipariş bir uçuşu, bir oteli ve bir ek hizmeti paketleyebilir — her biri aynı referans / PNR altında bir kalemdir.' },
        { title: 'Durum ne yapacağınızı söyler', desc: 'Taslak → Tutuldu → Onaylandı → Ödendi, ayrıca İncelemede (onay bekleyen bir Talep Üzerine konaklama) ve İptal Edildi — çip bir rezervasyonun nerede olduğunu gösterir.' },
        { title: 'Servis yüzeyi', desc: 'Her satış sonrası işlem (iptal, iade, ücretler, belgeler) siparişi burada bularak başlar.' },
      ],
    },
    software: {
      lead: 'Aranabilir, filtrelenebilir bir sipariş tablosu — ve global üst çubuk aramasının hedefi.',
      points: [
        { title: 'Hızlı bulun', desc: 'Referans, PNR, yolcu veya irtibata göre arayın; ürün, durum veya tarihe göre filtreleyin.' },
        { title: 'Global arama buraya gelir', desc: 'Benzersiz bir sonuç olmayan bir üst çubuk araması eşleşmelerini burada listeler; benzersiz bir sonuç doğrudan rezervasyon detayına atlar.' },
        { title: 'Servis için açın', desc: 'Tam rezervasyon detayını açmak ve üzerinde işlem yapmak için bir satıra tıklayın.' },
      ],
    },
    related: ['booking-detail', 'queue', 'refunds', 'counter'],
  },

  'booking-detail': {
    title: 'Rezervasyon detayı',
    tag: 'Sipariş kaydı',
    tagline: 'Bir siparişin tam beş katmanlı kaydı — kalemler, para, ödemeler, belgeler ve işlemler.',
    business: {
      lead: 'Bir rezervasyon beş katmanda modellenir — Sipariş → Kalem → Tedarikçi referansı → Belge → Kupon — böylece her ücret, vergi, komisyon ve iade tam olarak ait olduğu şeye atfedilir. Bu ekran, bir siparişin uçtan uca anlaşıldığı ve servis edildiği yerdir.',
      points: [
        { title: 'Beş katman, tam atıf', desc: 'Para kuponlardan ve belgelerden kalemlere, ardından siparişe yuvarlanır, böylece kimin ne borçlu olduğunu her zaman bilirsiniz.' },
        { title: 'Her seviyede iptal', desc: 'Tek bir kuponu, bir belgeyi, bir kalemi veya tüm siparişi iptal edin — her zaman herhangi bir para hareket etmeden önce bir teklifle.' },
        { title: 'Talep Üzerine burada yaşar', desc: 'Bekleyen (İncelemede) bir otel talebi bir Onayla / Reddet çubuğu gösterir — Onayla yetkilendirilmiş ödemeyi tahsil eder, Reddet onu iptal eder.' },
      ],
    },
    software: {
      lead: 'Seviye başına finansal bilgiler ve satış sonrası işlemlerle sekmeli bir kayıt.',
      points: [
        { title: 'Kalemler', desc: 'Kalem bazlı döküm — her ürün, segmentleri / odaları, yolcuları ve durumuyla bir kalem olarak.' },
        { title: 'Finansallar', desc: 'Para matrisi: her seviyede net, kâr marjları, vergiler, ücretler, indirimler, komisyonlar ve marj.' },
        { title: 'Ödemeler', desc: 'Ödeme ayakları (yetkilendirildi / tahsil edildi / iade edildi / iptal edildi) ve ödenmesi gereken bakiye.' },
        { title: 'Belgeler', desc: 'Düzenlenmiş tedarikçi belgeleri; bir uçuş e-bileti yazdırmaya hazır, iki dilli Uçuş Bileti Vaucheri’ni açar ve acente taramaları eklenebilir.' },
        { title: 'Ücretler', desc: 'Rezervasyon sonrası ücretler — ücret, ek hizmet, ceza veya indirim ekleyin ve yapısal değişiklikler (yolcu / kalem ekle, ad düzeltmesi) KDV ile.' },
        { title: 'Talepler', desc: 'Bu rezervasyonun kalemleri üzerinde acente ile platform masası arasında açılan destek talepleri.' },
        { title: 'İptal & iade', desc: 'Herhangi bir seviyede bir iptali teklif edin ve uygulayın; iadeler İadeler & İptaller onay iş akışına yönlendirilir.' },
      ],
    },
    examples: [
      {
        title: 'Para nasıl yuvarlanır (bir otel kalemi)',
        rows: [
          { label: 'Tedarikçi net', value: '7,400,000' },
          { label: '+ Perakende kâr marjı', value: '+1,110,000', accent: 'info' },
          { label: '+ Ek hizmetler & KDV', value: '+990,000', accent: 'success' },
          { label: 'Satış toplamı', value: '9,500,000', strong: true, accent: 'accent' },
          { label: '− Ödenen', value: '9,500,000' },
          { label: 'Ödenecek bakiye', value: '0', strong: true },
        ],
        note: 'Sipariş toplamı kalemlerinin toplamıdır; her kalemin satış toplamı, kendisine atfedilen net artı kâr marjı katmanları, ücretler ve vergilerdir.',
      },
    ],
    related: ['bookings', 'refunds', 'queue'],
  },

  queue: {
    title: 'Rezervasyon kuyruğu',
    tag: 'PNR tutmaları',
    tagline: 'Hâlâ biletleme veya tedarikçi işlemi gerektiren envanter tutan PNR’ler.',
    business: {
      lead: 'Tutulan bir PNR envanteri rezerve eder ancak henüz biletlenmemiştir — bir son teslim tarihine dair bir sözdür. Kuyruk bunları yüzeye çıkarır, böylece personel tutma süresi dolmadan ve koltuk veya oda otomatik olarak tedarikçiye geri bırakılmadan önce işlem yapar.',
      points: [
        { title: 'Tutmalar bozulabilir', desc: 'Biletlenmemiş PNR’ler, tutma pencereleri geçtiğinde otomatik iptal olur (bir süpürücü her 60 saniyede bir çalışır), envanteri serbest bırakır.' },
        { title: 'Saati yenin', desc: 'Biletleme süresi önemli olan metriktir — zamanında düzenleyin yoksa rezervasyon kaybolur.' },
        { title: 'Yalnızca biletleme değil', desc: 'Bazı satırlar yalnızca sizin düzenleme işleminizi değil, bir tedarikçiyi (ör. bir Talep Üzerine onayı) bekliyor.' },
      ],
    },
    software: {
      lead: 'Son teslim tarihleriyle zamana göre sıralanmış bir tutmalar iş listesi.',
      points: [
        { title: 'Neyin sona erdiğini görün', desc: 'Her satır tutma bitişini gösterir, böylece en acil olanlar en üste çıkar.' },
        { title: 'Bir satırda işlem yapın', desc: 'Düzenlemek / biletlemek veya gerekli tedarikçi işlemini yapmak için rezervasyonu açın.' },
        { title: 'Otomatik iptal otomatiktir', desc: 'Süresi dolan tutmalar arka plan süpürücüsü tarafından serbest bırakılır ve kuyruktan düşer.' },
      ],
    },
    related: ['bookings', 'booking-detail'],
  },

  refunds: {
    title: 'İadeler & İptaller',
    tag: 'Satış sonrası para',
    tagline: 'Parayı geri verme için kontrollü iş akışı — iptaller, iadeler ve void’ler.',
    business: {
      lead: 'Bir rezervasyon iptal edildiğinde para doğru ve kontrol altında geri hareket etmelidir. İadeler & İptaller, taleplerin oluşturulduğu ve onaylandığı yerdir, böylece iadeler ücret kurallarını takip eder ve bir kontrol olmadan hiçbir şey çıkmaz.',
      points: [
        { title: 'Başlatma vs onaylama', desc: 'Bir iade oluşturmak ve onaylamak ayrı adımlardır — onay, kendi iznine bağlı tutulan para-hareket eder geçididir.' },
        { title: 'Void vs iade', desc: 'Bir void, hiç tahsil edilmemiş bir yetkilendirmeyi iptal eder (hiçbir şey tahsil edilmedi); bir iade, herhangi bir cezayı düşerek tahsil edilen parayı geri verir.' },
        { title: 'Kurallar, tahmin değil', desc: 'Tutarlar ücret / iptal kurallarını ve herhangi bir cezayı takip eder; talep dökümü kaydeder.' },
      ],
    },
    software: {
      lead: 'Durumları ve tutarlarıyla bir iade / void talepleri kuyruğu.',
      points: [
        { title: 'Kuyruğu işleyin', desc: 'Bekleyen talepleri tutarı, cezası ve nedeniyle görün.' },
        { title: 'Onaylayın veya reddedin', desc: 'Parayı hareket ettirmek için onaylayın (tahsilatı iade edin / yetkilendirmeyi void edin) veya bir nedenle reddedin.' },
        { title: 'İzlenebilir', desc: 'Her karar atfedilir ve kaynak rezervasyona geri bağlanır.' },
      ],
    },
    related: ['booking-detail', 'bookings'],
  },

  counter: {
    title: 'Gişe',
    tag: 'Nakit & POS',
    tagline: 'Kasiyer vardiyaları, nakit ve POS hareketleri ve gün sonu mutabakatı.',
    business: {
      lead: 'Fiziksel bir gişe üzerinden satış yapan acenteler için bu, nakit kontrol katmanıdır: kimin vardiyada olduğunu, her nakit ve kart hareketini izler ve alınanların kayıtla eşleşmesi için gün sonunda kasayı denkleştirir.',
      points: [
        { title: 'Vardiya başına hesap verebilirlik', desc: 'Bir vardiyayı açmak ve kapatmak her hareketi bir kasiyere ve bir oturuma bağlar.' },
        { title: 'Nakit disiplini', desc: 'Nakit ve POS hareketlerini olurken kaydetmek, gün sonu mutabakatını mümkün kılan şeydir.' },
        { title: 'Mutabık kalın, tahmin etmeyin', desc: 'Gün sonu, beklenen ile sayılanı karşılaştırır, böylece bir tutarsızlık hemen yüzeye çıkar.' },
      ],
    },
    software: {
      lead: 'Hareketleri ve mutabakatı ile mevcut vardiya için bir gösterge paneli.',
      points: [
        { title: 'Bir vardiya açın / kapatın', desc: 'Kaydetmeye başlamak için bir oturum başlatın; mutabık kalmak için kapatın.' },
        { title: 'Hareketleri kaydedin', desc: 'Vardiya sırasında nakit giriş / çıkış ve POS işlemlerini kaydedin.' },
        { title: 'Kapanışta mutabık kalın', desc: 'Beklenen ile sayılanı karşılaştırın ve farkı kaydedin.' },
      ],
    },
    related: ['bookings', 'refunds'],
  },
};
